
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'TheProfessionalConsultationScrollItem',
  components: {},
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  computed: {
    ...mapState('expedient', ['currentExpedient', 'consultations']),
    ...mapState('treatment', ['currentTreatment']),
    ...mapState('consultation', ['currentConsultation']),
    ...mapState('user', ['authUser']),
    ...mapState('app', ['formsSettings']),
    canShowConsultation(): boolean {
      return this.can('professional.expedient.consultation.show')
        || this.can('patient.expedient.consultation.show');
    },
  },
  methods: {
    type(consultation) {
      const type = this.formsSettings.consultation_type_options.find((o) => o.key === consultation.type);

      return type.label;
    },
    async setConsultation(consultation) {
      await this.$store.dispatch('consultation/getCurrentConsultation', {
        expedientId: this.currentExpedient.id,
        consultationId: consultation.id,
      });

      const route = this.authUser.role.name === 'Paciente' ? 'patient.expedient.show' : 'professional.expedient.show';

      await this.$router.push({
        name: route,
        params: {
          expedient: this.currentExpedient.id,
          tabName: 'consultas',
          consultation: consultation.id,
        },
        query: { tratamiento: this.currentTreatment?.id },
      });
    },
  },

});
